import { useCallback } from 'react';
import { useLoading } from '../../../context';

export const useSubmitRegister = () => {
  const { showLoading, hideLoading } = useLoading();

  const submitRegister = useCallback(
    async (formData) => {
      showLoading();
      try {
        const response = await fetch('/api/user/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: formData.email,
            firstName: formData.firstName,
            lastName: formData.lastName,
            password: formData.password,
            mobile: `${formData.dialCode}${formData.phoneNumber}`,
            roles: ['CUSTOMER'],
          }),
        });
        if (response.ok) {
          const data = await response.json();
          return data.data;
        } else {
          throw new Error(await response.json());
        }
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        hideLoading();
      }
    },
    [hideLoading, showLoading]
  );

  return { submitRegister };
};
